"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 1,
    class: "main w-full flex"
};
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const BackToTop_vue_1 = __importDefault(require("../components/Layout/BackToTop.vue"));
//import Navbar from "../components/Layout/Navbar.vue";
const Navbar_vue_1 = __importDefault(require("../components/Layout/backend/Navbar.vue"));
const Head_vue_1 = __importDefault(require("../components/Layout/backend/Head.vue"));
const Toasts_vue_1 = __importDefault(require("../components/Layout/Toasts.vue"));
const ServerError_1 = __importDefault(require("../common/error/ServerError"));
//import Foot from "../components/Layout/Foot.vue";
const securityStore_1 = require("../stores/security/securityStore");
const appLoginStore_1 = require("../stores/appLogin/appLoginStore");
const CompanyLocationStore_1 = require("../stores/backend/company/CompanyLocationStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'App',
    setup(__props) {
        const T = (0, vue_3.inject)("Translator");
        const route = (0, vue_router_1.useRoute)();
        const router = (0, vue_router_1.useRouter)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const appLoginStore = (0, appLoginStore_1.useAppLoginStore)();
        const companyLocationStore = (0, CompanyLocationStore_1.useCompanyLocationStore)();
        //Ha a felhasználó auth nem true akkor resetelni kell a storet, bejelentkezésnél viszont le kell kérni újra a vállalatokat és a telephelyeket!
        (0, vue_3.watch)(() => [securityStore.authenticated], async ([NewAuth]) => {
            if (NewAuth === true) {
                //kiolvassa ha van kiválasztott company és telephely ha nincs beállítja az elsőket
                await companyLocationStore.readStorage();
            }
            else {
                //kijelentkezésnél kiüríti a store-t
                companyLocationStore.$reset();
            }
        }, { immediate: true } // Azonnali futtatás bekapcsolva
        );
        //const errorMessage: Ref<string> = ref<string>('');
        //securityStore.initApplogin(router);
        const isLoginPage = (0, vue_3.computed)(() => "admin_login" === router.currentRoute.value.name);
        const isRequiresAdminAuth = (0, vue_3.computed)(() => router.currentRoute.value.meta.requiresAuth);
        const isRequiresAppAuth = (0, vue_3.computed)(() => router.currentRoute.value.meta.requiresAppAuth);
        const tokenExpirationInEpochSeconds = (0, vue_3.computed)(() => {
            if (securityStore.authenticatedUser === null) {
                return 0;
            }
            return securityStore.authenticatedUser.exp;
        });
        const hasDefaultLayout = (0, vue_3.computed)(() => {
            if (route.meta.hasDefaultLayout === undefined) {
                return true;
            }
            if (typeof route.meta.hasDefaultLayout !== "boolean") {
                return true;
            }
            return (typeof route.meta.hasDefaultLayout === "boolean" &&
                Boolean(route.meta.hasDefaultLayout));
        });
        (0, vue_3.onBeforeMount)(async () => {
            try {
                await securityStore.refreshToken(router);
                await securityStore.checkAuth(router);
                setInterval(() => {
                    let nowInEpochSeconds = Math.floor(Date.now() / 1000);
                    if (nowInEpochSeconds >
                        tokenExpirationInEpochSeconds.value - 300) {
                        securityStore.refreshToken(router).catch(() => {
                            router.push({ name: "admin_login" });
                        });
                    }
                }, 60000, tokenExpirationInEpochSeconds);
                const redirect = router.resolve(route.query.redirect ? `${route.query.redirect}` : route);
                if (redirect.name === route.name) {
                    return;
                }
                if (redirect.name) {
                    await router.replace({ name: redirect.name });
                    return;
                }
            }
            catch (error) {
                if (error instanceof ServerError_1.default &&
                    error.responseData.redirect &&
                    error.responseData.redirect.length &&
                    route.name !== router.resolve(error.responseData.redirect).name) {
                    // checkAuth fails
                    await router.push(error.responseData.redirect);
                }
                //if route contains the "admin" word it will redirect the login page
                if (route.fullPath.includes("admin")) {
                    // refreshToken fails or other error
                    await router.push({ name: "admin_login" });
                    return;
                }
            }
        });
        (0, vue_3.onBeforeMount)(async () => {
            try {
                await appLoginStore.initApplogin(router);
                // A többi kód...
            }
            catch (err) {
                console.error(err);
                // kezeld a hibát, pl. továbbítsd a felhasználót a bejelentkezési oldalra
            }
        });
        (0, vue_3.onUpdated)(() => {
            let title = route.meta.title
                ? //@ts-expect-error
                    T === null || T === void 0 ? void 0 : T.trans(route.meta.title.toLowerCase(), route.meta.title, "app")
                : "";
            window.document.title = `${title} - MARSO`;
        });
        return (_ctx, _cache) => {
            const _component_router_view = (0, vue_2.resolveComponent)("router-view");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (!hasDefaultLayout.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_view, { key: 0 }))
                    : (0, vue_2.createCommentVNode)("", true),
                (hasDefaultLayout.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                        ((0, vue_2.unref)(securityStore).authenticated &&
                            isRequiresAdminAuth.value &&
                            _ctx.$route.path.includes('admin'))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Navbar_vue_1.default, { key: 0 }))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", {
                            class: (0, vue_2.normalizeClass)(isRequiresAdminAuth.value &&
                                _ctx.$route.path.includes('admin') &&
                                (0, vue_2.unref)(companyLocationStore).selectedCompany &&
                                (0, vue_2.unref)(companyLocationStore).selectedLocation
                                ? 'admin-container'
                                : 'w-full')
                        }, [
                            ((0, vue_2.unref)(securityStore).authenticated &&
                                isRequiresAdminAuth.value &&
                                _ctx.$route.path.includes('admin') &&
                                (0, vue_2.unref)(companyLocationStore).selectedCompany &&
                                (0, vue_2.unref)(companyLocationStore).selectedLocation)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Head_vue_1.default, { key: 0 }))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createVNode)(_component_router_view, {
                                class: (0, vue_2.normalizeClass)(isLoginPage.value ? 'app-content-login' : 'app-content')
                            }, {
                                default: (0, vue_2.withCtx)(({ Component }) => [
                                    (((0, vue_2.unref)(securityStore).authenticated || !isRequiresAdminAuth.value) &&
                                        !isRequiresAppAuth.value &&
                                        (0, vue_2.unref)(companyLocationStore).selectedCompany &&
                                        (0, vue_2.unref)(companyLocationStore).selectedLocation)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)(Component), { key: 0 }))
                                        : (((0, vue_2.unref)(appLoginStore).authenticated || !isRequiresAppAuth.value) &&
                                            !isRequiresAdminAuth.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)(Component), { key: 1 }))
                                            : (0, vue_2.createCommentVNode)("", true)
                                ]),
                                _: 1
                            }, 8, ["class"])
                        ], 2),
                        (0, vue_2.createVNode)(Toasts_vue_1.default),
                        (0, vue_2.createVNode)(BackToTop_vue_1.default)
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
